import { observer } from 'mobx-react-lite';

import Detail from '@/pages/Detail';
import Main from '@/pages/Main';

import { SEOMetaTag } from '@popularKeyword/common-components';

import { useSearchParams } from '@popularKeyword/common-hooks';
import useStore from '@/hooks/useStore';
import ErrorBoundary from '@/components/common/ErrorBoundary';

const PopularKeyword = () => {
  const { SEOStore } = useStore();
  const { title, description, keywords, mwUrl } = SEOStore;

  const params = useSearchParams();
  const { type } = params;

  return type === 'detail' ? (
    <>
      <ErrorBoundary groupName="Detail">
        <Detail />
      </ErrorBoundary>
      <SEOMetaTag title={title} description={description} keywords={keywords} alternateUrl={mwUrl} />
    </>
  ) : (
    <>
      <ErrorBoundary groupName="Main">
        <Main />
      </ErrorBoundary>
      <SEOMetaTag title={title} description={description} keywords={keywords} alternateUrl={mwUrl} />
    </>
  );
};

export default observer(PopularKeyword);
